"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _List = require('web/screens/App/List');
var _Header = require('./Header'); var _Header2 = _interopRequireDefault(_Header);
var _List3 = require('./List'); var _List4 = _interopRequireDefault(_List3);








const DirectorySidebar = ({
  onSelectTab,
  selectedTab,
  orgKey,
  onRequestPatientsFeature,
}) => (
  _react2.default.createElement(_List.List, { className: "inbox-list directory-list" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
    , _react2.default.createElement(_Header2.default, {
      orgKey: orgKey,
      selectedTab: selectedTab,
      onRequestPatientsFeature: onRequestPatientsFeature, __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
    )
    ,  orgKey && (
      _react2.default.createElement(_List4.default, {
        orgKey: orgKey,
        selectedTab: selectedTab,
        onSelectTab: onSelectTab, __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      )
    )
  )
)

exports. default = _react.memo.call(void 0, DirectorySidebar)
